import { useMemo } from 'react'
import { CircularProgress, Stack, Typography } from '@mui/material'
import { useSearchParams } from 'react-router-dom'
import { useLazyGetUsersPageQuery } from '../../../../api/users'
import { UsersList } from '../../../../components/Users/UsersList'
import { usersListQueryArgsFromSearchParams } from '../../../../components/Users/usersListQueryArgs'
import { useUsersWindowedPage } from '../../../../hooks/useUsersWindowedPage'

export const UsersAll = () => {
  const [searchParams] = useSearchParams()
  const usersQueryArgs = useMemo(() => usersListQueryArgsFromSearchParams(searchParams), [searchParams])
  const resetKey = useMemo(() => JSON.stringify(usersQueryArgs), [usersQueryArgs])

  const [loadUsersPage] = useLazyGetUsersPageQuery()
  const {
    items,
    hasMore,
    isInitialLoading,
    isFetchingMore,
    isError,
    loadMore,
  } = useUsersWindowedPage(resetKey, loadUsersPage, usersQueryArgs)

  if (isInitialLoading && items.length === 0) {
    return (
      <Stack alignItems="center" justifyContent="center" minHeight="100%">
        <CircularProgress />
      </Stack>
    )
  }

  if (isError) {
    return (
      <Typography color="error" textAlign="center" px={2}>
        Не удалось загрузить пользователей
      </Typography>
    )
  }

  return (
    <UsersList
      users={items}
      hasMore={hasMore}
      isLoadingMore={isFetchingMore && hasMore}
      onLoadMore={() => void loadMore()}
    />
  )
}
